/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronLeft } from "@mui/icons-material";
import {
  Button,
  Backdrop,
  CircularProgress,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { CHANGE_TITLE } from "../../../../store/theming";
import FormCreateBanner from "./FormCreateBanner";

const tab = ["Detail Banner", "Jadwal Publish"];

const UpdateBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [tabActive, setTabActive] = useState("Detail Banner");

  useEffect(() => {
    dispatch(CHANGE_TITLE(`Ubah Banner`));
  }, []);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Button
        variant="contained"
        style={{ minWidth: "0" }}
        className="capitalize rounded-lg  mb-3"
        onClick={() => navigate(-1)}
      >
        <ChevronLeft /> Kembali
      </Button>
      <Box
        className="mb-5 mt-5"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tabs value={tabActive} onChange={(e) => setTabActive(e.target.id)}>
          {tab.map((value) => {
            return (
              <Tab
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: "700",
                }}
                key={value}
                id={value}
                className="capitalize"
                label={value}
                value={value}
              />
            );
          })}
        </Tabs>
      </Box>
      <FormCreateBanner
        id={id}
        stateUpdate={state}
        setLoading={setLoading}
        tabActive={tabActive}
        setTabActive={setTabActive}
      ></FormCreateBanner>
    </>
  );
};

export default UpdateBanner;
